import { render, staticRenderFns } from "./PersonItems.vue?vue&type=template&id=e303a6f2"
import script from "./PersonItems.vue?vue&type=script&lang=js"
export * from "./PersonItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports